/* eslint-disable */
import React from 'react';

interface NavigationDotsProps {
  active: string;
}

const NavigationDots: React.FC<NavigationDotsProps> = ({ active }) => {
  return (
    <div className='app__navigation'>
        {['home', 'about', 'work', 'systems', 'skills', 'Testimonials', 'contact'].map((item, index) => (
            <a 
                href={`#${item}`} 
                key={item + index}
                className="app__navigation-dot"
                style={active === item ? {background: 'var(--secondary-color)' } : { }}
            >
                <span className="visually-hidden">{item}</span>
            </a>
        ))}        
    </div>
  )
}

export default React.memo(NavigationDots)